import React from 'react';
const Colors = () => {
    return ( 
    <h3>hello</h3> 
    );
}
 
export {Colors};